var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1rem",
    viewBox: "0 0 17.339 25.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "microphone-lines-solid_1_",
    "data-name": "microphone-lines-solid (1)",
    d: "M19.941,4.729V12.61a4.729,4.729,0,1,0,9.457,0H25.457a.788.788,0,0,1,0-1.576H29.4V9.457H25.457a.788.788,0,0,1,0-1.576H29.4V6.3H25.457a.788.788,0,1,1,0-1.576H29.4a4.729,4.729,0,1,0-9.457,0Zm11.034,7.093v.788a6.3,6.3,0,0,1-12.61,0V10.64a1.182,1.182,0,1,0-2.364,0v1.97a8.673,8.673,0,0,0,7.487,8.59v1.655H21.123a1.182,1.182,0,1,0,0,2.364h7.093a1.182,1.182,0,0,0,0-2.364H25.851V21.2a8.673,8.673,0,0,0,7.487-8.59V10.64a1.182,1.182,0,1,0-2.364,0Z",
    transform: "translate(-16)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneIcon);
export default __webpack_public_path__ + "static/media/microphone-icon.ae8b95763c3e444b71a393194fad3773.svg";
export { ForwardRef as ReactComponent };